import { useEffect, useId } from "react";
import { addSelectorPath } from "../actions/addSelectorPath";
import { removeSelectorPath } from "../actions/removeSelectorPath";
import { useConfigurationDispatch } from "../context/ConfigurationReduxContext";
export const PERSIST_PREFIX = "persist";
function useSubscriberId(persist) {
    const baseId = useId();
    return persist ? `${PERSIST_PREFIX}${baseId}` : baseId;
}
export function useSubscribeToPath(path, persist) {
    const subscriberId = useSubscriberId(persist);
    const dispatch = useConfigurationDispatch();
    useEffect(() => {
        // add the selector, refetch is done by the effect below
        dispatch(addSelectorPath({ path, subscriberId }));
        return () => {
            // we remove only this exact selector reference again
            // this prevent issues with setting the selectors elsewhere
            dispatch(removeSelectorPath({ path, subscriberId }));
        };
    }, [path, subscriberId, dispatch]);
}
//# sourceMappingURL=useSubscribeToPath.js.map